import { createImmutableMap } from 'ctm-util-functions';
import Immutable from 'immutable';

export const createPrefillVerifyReducer = () => {
    const initialState = createImmutableMap({
        showWelcomeBack: false,
        isVerifying: false,
        verifyFailed: false
    });
    return (state = initialState, action) => {
        switch (action.type) {
            case 'SET_VERIFY_RESPONSE': {
                return state.setIn(['response'], Immutable.fromJS(action.payload));
            }
            case 'SET_SHOW_WELCOME_BACK':
                return state.set('showWelcomeBack', action.payload);
            case 'SET_IS_VERIFYING':
                return state.set('isVerifying', action.payload);
            case 'SET_VERIFY_FAILED':
                return state.set('verifyFailed', action.payload);
            default:
                return state;
        }
    };
};
